import React from 'react';

import { Typography, Box } from '@material-ui/core';

import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { QRCode, QRCodeWrapper, StoreImgWrapper } from './ReadyToStartSleepio.styles';

import { getPlatform } from '../../utils/platformHelpers';
import { OnboardingParams } from '../../types';

import EmoCloudSleep from '@/assets/EmoCloudSleep.svg';
import AppStore from '@/assets/AppStore.svg';
import GooglePlay from '@/assets/GooglePlay.svg';
import { Platform, getProductName, isDaylight as isDaylightProduct } from '@/utils/productHelpers';
import {
  DAYLIGHT_APP_STORE_URL, DAYLIGHT_GOOGLE_PLAY_URL, SLEEPIO_APP_STORE_URL, SLEEPIO_GOOGLE_PLAY_URL,
} from '@/pages/Onboarding/utils/constants';

export const ReadyToStartSleepio: React.FC = () => {
  const { t } = useTranslation();
  const platform = getPlatform();
  const { product } = useParams<OnboardingParams>();
  // Daylight reuses this Sleepio screen, so point it at the Daylight app
  const isDaylight = isDaylightProduct(product);
  const productName = { productName: getProductName(product) };

  let storeLink;
  let title = t('coverage.sleepio.patient.download_sleepio_title', productName);
  let subtitle1 = t('coverage.sleepio.patient.download_sleepio_subtitle_1', productName);
  let subtitle2 = '';

  if (platform === Platform.Android) {
    storeLink = (
      <StoreImgWrapper href={isDaylight ? DAYLIGHT_GOOGLE_PLAY_URL : SLEEPIO_GOOGLE_PLAY_URL}>
        <img
          alt="Play Store"
          src={GooglePlay}
        />
      </StoreImgWrapper>
    );
  } else if (platform === Platform.iOS) {
    storeLink = (
      <StoreImgWrapper href={isDaylight ? DAYLIGHT_APP_STORE_URL : SLEEPIO_APP_STORE_URL}>
        <img
          alt="App Store"
          src={AppStore}
        />
      </StoreImgWrapper>
    );
  } else {
    storeLink = (
      <QRCodeWrapper>
        <QRCode
          data-testid="qr-code"
          value={`${window.location.origin}/appstore/${isDaylight ? 'daylight' : 'sleepio'}`}
        />
      </QRCodeWrapper>
    );
    title = t('coverage.sleepio.patient.download_sleepio_title_desktop');
    subtitle1 = t('coverage.sleepio.patient.download_sleepio_subtitle_1_desktop', productName);
    subtitle2 = t('coverage.sleepio.patient.download_sleepio_subtitle_2_desktop');
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    }}
    >
      <Box sx={{ textAlign: 'center', width: '100%', paddingTop: 26 }}>
        <img
          alt="Emo Cloud Sleep"
          style={{ width: '206px' }}
          src={EmoCloudSleep}
        />
      </Box>
      <Typography variant="h2">{title}</Typography>
      <Typography style={{ paddingBottom: 16 }}>
        {subtitle1}
      </Typography>
      {storeLink}
      <Typography>{subtitle2}</Typography>
    </Box>
  );
};
